import cx from 'classnames';
import EnquiryTypes from 'constants/EnquiryTypes';

import QuestionFormContainer from '../QuestionFormContainer/QuestionFormContainer';
import SectionWithContainer, {
  SectionWithContainerProps,
} from '../SectionWithContainer/SectionWithContainer';

interface QuestionFormContainerSectionProps extends SectionWithContainerProps {
  onSubmit: (response: any) => any;
  withSpecificCarFields?: boolean;
  title?: string;
  subTitle?: string;
  enquiryType?: EnquiryTypes;
  vehicleVin?: string;
}

const QuestionFormContainerSection = ({
  className,
  onSubmit,
  withSpecificCarFields,
  title = 'Got any questions?',
  subTitle = 'Feel like you need to speak to someone? Fill out the form and we’ll get back to you.',
  enquiryType = EnquiryTypes.GotAnyQuestions,
  vehicleVin,
  ...props
}: QuestionFormContainerSectionProps) => {
  return (
    <SectionWithContainer className={cx('bg-blue-5', className)} {...props}>
      <h2 className="mb-8 font-light text-center text-dark-blue-100">
        {title}
      </h2>
      <h4 className="font-light text-center mb-7">{subTitle}</h4>
      <div className="flex items-center justify-center max-w-screen-sm mx-auto">
        <QuestionFormContainer
          withSpecificCarFields={withSpecificCarFields}
          className="w-full"
          onSubmit={onSubmit}
          enquiryType={enquiryType}
          vehicleVin={vehicleVin}
        />
      </div>
    </SectionWithContainer>
  );
};

export default QuestionFormContainerSection;
